import { Injectable } from '@angular/core';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  private hubConnection: HubConnection;

  constructor() { }

  // 啟動 SignalR 連接
  public startConnection() {
    this.hubConnection = new HubConnectionBuilder()
      .withUrl(environment.urls.webUrl+'/languageUpdateHub') // 這是後端 SignalR Hub 的 URL
      .build();

    // 建立連接
    this.hubConnection.start().catch(err => console.error('SignalR 連接錯誤: ', err));
  }

  // 訂閱語系更新事件
  public onLanguageUpdated(callback: () => void) {
    this.hubConnection.on('languageUpdated', callback);
  }

  // 停止 SignalR 連接
  public stopConnection() {
    if (this.hubConnection) {
      this.hubConnection.stop().catch(err => console.error('停止 SignalR 連接錯誤: ', err));
    }
  }
}